import { get, put } from 'helpers/apiHelpers';
import types from 'helpers/constants';

export const getCompany = iri => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  get(iri).then(response => {
    dispatch({
      type: types.FETCH_COMPANY,
      payload: response,
    });
    dispatch({
      type: types.TRANSLATABLE_SELECT_LANGUAGE,
      payload: { selectedLanguage: response.language },
    });

    return response;
  });

export const saveCompany = (iri, data) => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  put(iri, data).then(response => {
    dispatch({
      type: types.FETCH_COMPANY,
      payload: response,
    });
    dispatch({
      type: types.TRANSLATABLE_SELECT_LANGUAGE,
      payload: { selectedLanguage: response.language },
    });

    return response;
  });
